import { configureStore } from '@reduxjs/toolkit';

import authReducer from '../Module/Auth/Presentation/authSlice';
import projectReducer from '../Module/Project/Presentation/projectSlice';
import userReducer from '../Module/User/Presentation/userSlice';
import settlementReducer from '../Module/Settlement/Presentation/settlementSlice';

export const store = configureStore({
  reducer: {
    auth: authReducer,
    project: projectReducer,
    user: userReducer,
    settlement: settlementReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

